<template>
  <section
    :id="module.id"
    class="image-text-wrapper"
    :style="[imageTextWrapperElStyles]"
  >
    <GlobalUIMedia
      v-if="module.config.general.showMedia"
      :media="module.config.general.media"
      :lazy="lazy"
    />
    <div class="inner-wrapper" :style="modulePadding">
      <component :is="module.config.general.template.component">
        <template #text>
          <div
            class="text"
            :style="textElStyles"
            v-html="module.config.text.text"
          ></div>
        </template>

        <template #image>
          <img
            v-if="isColumnLayout"
            :src="appendCdnParams(module.config.media.media.url)"
            :srcset="
              setImageSrcSet(
                module.config.media.media.url,
                mobileWidthColumn,
                tabletWidthColumn,
                laptopWidthColumn,
                desktopWidthColumn,
              )
            "
            :sizes="
              setImageSizes(
                mobileWidthColumn,
                tabletWidthColumn,
                laptopWidthColumn,
                desktopWidthColumn,
              )
            "
            :alt="module.config.media.mediaAltText"
            :style="mediaElStyles"
            :loading="lazy ? 'lazy' : 'eager'"
          />

          <img
            v-else
            :src="appendCdnParams(module.config.media.media.url)"
            :srcset="
              setImageSrcSet(
                module.config.media.media.url,
                mobileWidthRow,
                tabletWidthRow,
                laptopWidthRow,
                desktopWidthRow,
              )
            "
            :sizes="
              setImageSizes(
                mobileWidthRow,
                tabletWidthRow,
                laptopWidthRow,
                desktopWidthRow,
              )
            "
            :alt="module.config.media.mediaAltText"
            :style="mediaElStyles"
            :loading="lazy ? 'lazy' : 'eager'"
          />
        </template>
      </component>
    </div>
  </section>
</template>

<script>
import imageTextModule from "./imageTextDefaultModuleProps.js";
import ImageTextTopLeft from "./Templates/ImageTextTopLeft.vue";
import ImageTextTopCenter from "./Templates/ImageTextTopCenter.vue";
import ImageTextTopRight from "./Templates/ImageTextTopRight.vue";

import ImageTextBottomLeft from "./Templates/ImageTextBottomLeft.vue";
import ImageTextBottomCenter from "./Templates/ImageTextBottomCenter.vue";
import ImageTextBottomRight from "./Templates/ImageTextBottomRight.vue";

import ImageTextRightTop from "./Templates/ImageTextRightTop.vue";
import ImageTextRightMiddle from "./Templates/ImageTextRightMiddle.vue";
import ImageTextRightBottom from "./Templates/ImageTextRightBottom.vue";

import ImageTextLeftTop from "./Templates/ImageTextLeftTop.vue";
import ImageTextLeftMiddle from "./Templates/ImageTextLeftMiddle.vue";
import ImageTextLeftBottom from "./Templates/ImageTextLeftBottom.vue";

import { globalComputed, globalMethods } from "../GlobalUI/mixins/global.js";
import { imageTextComputed } from "./mixins/imageText.js";
import GlobalUIMedia from "../GlobalUI/GlobalUIMedia.vue";

export default {
  components: {
    ImageTextTopLeft,
    ImageTextTopCenter,
    ImageTextTopRight,
    ImageTextBottomLeft,
    ImageTextBottomCenter,
    ImageTextBottomRight,
    ImageTextRightTop,
    ImageTextRightMiddle,
    ImageTextRightBottom,
    ImageTextLeftTop,
    ImageTextLeftMiddle,
    ImageTextLeftBottom,
    GlobalUIMedia,
  },
  name: "ImageText",
  mixins: [globalComputed, globalMethods, imageTextComputed],
  props: {
    module: {
      type: Object,
      default() {
        return imageTextModule;
      },
    },
    lazy: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mobileWidthColumn: 343,
      tabletWidthColumn: 770,
      laptopWidthColumn: 1152,
      desktopWidthColumn: 1572,
      mobileWidthRow: 343,
      tabletWidthRow: 416,
      laptopWidthRow: 862,
      desktopWidthRow: 1310,
    };
  },
  computed: {
    isColumnLayout() {
      return (
        this.module.config.general.template.component.startsWith(
          "ImageTextBottom",
        ) ||
        this.module.config.general.template.component.startsWith("ImageTextTop")
      );
    },
    imageTextWrapperElStyles() {
      const { backgroundColor } = this.module.config.general;

      return {
        backgroundColor: backgroundColor.value,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./scss/shared";

.image-text-wrapper {
  container-type: inline-size;
  contain: layout;

  display: grid;
  place-content: center;
}

.inner-wrapper {
  max-width: 1600px;
  margin: 0;
  margin-inline: var(--cr-spacing-l);

  @include tablet {
    margin-inline: var(--cr-spacing-m);
  }

  @include mobile {
    margin-inline: var(--cr-spacing-xs);
  }
}
</style>
